import React from 'react';

import {
    Redirect as RouterRedirect,
} from 'react-router';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import {
    ScrollToTopOnMount,
} from 'wanderu-hocs';

const TRANS_MODES = [
    'bus',
    'train',
    'ferry',
    'flight',
];

function onLoad(module, ...args) {
    module.onLoad(module, ...args);
}

const CarrierContactPage = withInterstitial(import('./pages/CarrierContact'), { onLoad });
const CarrierGuidePage = withInterstitial(import('./pages/CarrierGuide'), { onLoad });
const CityToCityPage = withInterstitial(import('./pages/CityToCity'), { onLoad });
const CityGuidePage = withInterstitial(import('./pages/CityGuide'), { onLoad });
const StateGuidePage = withInterstitial(import('./pages/StateGuide'), { onLoad });
const CountryGuidePage = withInterstitial(import('./pages/CountryGuide'), { onLoad });
const IndexGuidePage = withInterstitial(import('./pages/IndexGuide'), { onLoad });
const MultiModalCityToCityPage = withInterstitial(import('./pages/MultiModalCityToCity'), { onLoad });
const NewRoutesPage = withInterstitial(import('./pages/NewRoutes'), { onLoad });

export default [
    {
        path: '/carrier/',
        key: 'carrier-contact',
        component: ScrollToTopOnMount(CarrierContactPage),
        exact: true,
    },
    {
        path: '/carrier/:carrierGuideSlug-:carrierGuideId(\\d+)/', // carrierGuideId will pull the number off the end of the url
        key: 'carrier-guides',
        component: ScrollToTopOnMount(CarrierGuidePage),
        exact: true,
    },
    {
        path: '/carrier/:carrierGuideSlug-:carrierGuideId(\\d+)/:url*',
        key: 'carrier-redirect',
        component: (props) => {
            const {
                location,
                match,
            } = props;
            const {
                locale,
                carrierGuideSlug,
                carrierGuideId,
            } = match.params;

            const href = '/' + [
                locale,
                'carrier',
                `${carrierGuideSlug}-${carrierGuideId}`,
                location.search,
            ].join('/');

            return <RouterRedirect to={href} />;
        },
    },
    {
        path: '/travel/:fromRegion/:fromCity/:toRegion/:toCity/',
        key: 'multimodal-c2c',
        component: ScrollToTopOnMount(MultiModalCityToCityPage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})-tickets/`,
        key: 'index',
        exact: true,
        component: ScrollToTopOnMount(IndexGuidePage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})-tickets/:country-:state/`,
        key: 'state',
        exact: true,
        component: ScrollToTopOnMount(StateGuidePage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})-tickets/:country/`,
        key: 'country',
        exact: true,
        component: ScrollToTopOnMount(CountryGuidePage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})-tickets/:region/:city/`,
        key: 'city',
        exact: true,
        component: ScrollToTopOnMount(CityGuidePage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})-tickets/:region/:city/:url*`,
        key: 'city-redirect',
        component: (props) => {
            const {
                location,
                match,
            } = props;
            const {
                locale,
                mode,
                region,
                city,
            } = match.params;

            const href = '/' + [
                locale,
                `${mode}-tickets`,
                region,
                city,
                location.search,
            ].join('/');

            return <RouterRedirect to={href} />;
        },
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})/:fromRegion/:fromCity/:toRegion/:toCity/`,
        key: 'c2c',
        exact: true,
        component: ScrollToTopOnMount(CityToCityPage),
    },
    {
        path: `/:mode(${TRANS_MODES.join('|')})/:fromRegion/:fromCity/:toRegion/:toCity/:url*`,
        key: 'c2c-redirect',
        component: (props) => {
            const {
                location,
                match,
            } = props;
            const {
                locale,
                mode,
                fromRegion,
                fromCity,
                toRegion,
                toCity,
            } = match.params;

            const href = '/' + [
                locale,
                mode,
                fromRegion,
                fromCity,
                toRegion,
                toCity,
                location.search,
            ].join('/');

            return <RouterRedirect to={href} />;
        },
    },
    {
        path: '/new-routes/',
        key: 'new-routes',
        exact: true,
        component: ScrollToTopOnMount(NewRoutesPage),
    },
    {
        path: '/new-routes/*',
        key: 'new-routes',
        component: (props) => {
            const {
                match,
            } = props;
            const {
                locale,
            } = match.params;

            const href = `/${locale}/new-routes/`;

            return <RouterRedirect to={href} />;
        },
    },
];
